import React, {PropsWithChildren} from 'react'

import Icon from '../../icons/Icon'

export interface DrawerHeaderProps {
  headerText: string;
  onClose?: () => void;
}

const DrawerHeader = ({
  headerText,
  onClose,
  children
}: PropsWithChildren<DrawerHeaderProps>) => {
  const headerTextElement =
    <h2 className="font-titillium text-[28px] text-kwota-neutral-800 leading-[42px] font-semibold">
      {headerText}
    </h2>

  return (
    <div
      id="header"
      className="flex items-center justify-between w-full gap-4 mb-6"
    >
      {children ?
        <div className="flex gap-2">
          {headerTextElement}
          {children}
        </div>
        :
        headerTextElement
      }
      <button
        type="button"
        className="ml-auto"
        data-dismiss="modal"
        aria-label="Close"
        onClick={onClose}
      >
        <Icon icon="cross" size="md" />
      </button>
    </div>
  )
}

export default DrawerHeader
